/*
 * @Author: 薛莹
 * @LastEditors: 薛莹
 * @description: page description
 * @Date: 2021-09-09 13:34:15
 * @LastEditTime: 2021-09-10 10:00:15
 */
import axios from "axios";
import { getToken } from 'src/utils/auth'
import store from 'src/store'
axios.defaults.withCredentials = true;
// 基础地址
let baseURL = '/api';
console.log(process.env.common, '==============process.evn')
const service = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false

  if (getToken() && !isToken) {
    config.headers.Authorization = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config;
}, error => {
  console.log(error);
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
  //响应正确
  if (response.status >= 200 && response.status <= 210) {
    const data = response.data
    const code = data.code || 200
    const msg = data.msg || ''
    if (code == 401) {
      // message.error(msg);
      store.dispatch({
        type: 'USERINFO',
        userInfo: {}
      })
      return Promise.reject(new Error(msg))
    }
    else if (code !== 200) {
      // message.error(msg)
      return Promise.reject(data)
    } else {
      return data
    }
  }
  return response.data;
}, error => {
  return Promise.resolve(error.response.data);
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  try {
    return service({
      url,
      params,
      method: 'GET',
    })
  } catch (error) {
    console.error('get:', error);
  }
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
  try {
    return service({
      url,
      data,
      method: 'POST',
    });
  } catch (error) {
    console.error('post:', error);
  }
}
export default service